module.exports = __webpack_public_path__ + "img/beta.7988a398.svg";